
























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class StatValueCard extends Vue {
  @Prop() fieldKey!: string

  @Prop() value!: number | string

  @Prop() icon!: string
}
